import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import Swal from "sweetalert2";
import { CandidatoService } from "../_shared/candidato/candidato.service";
import { DocumentoGlobal } from "../_shared/documento/documento-global";
import { DocumentoService } from "../_shared/documento/documento.service";
import { ParametrosGeraisService } from "../_shared/parametros-gerais/parametros-gerais.service";
import { SessionService } from "../_shared/session/session.service";

@Component({
  selector: "app-documento-upload",
  templateUrl: "./documento.component.html",
  styleUrls: ["./documento.component.css"],
})
export class DocumentoComponent implements OnInit {
  documentType = null;

  documentos = [];

  documentosCandidato = [];

  constructor(
    protected candidato: CandidatoService,
    protected documentosGlobal: DocumentoGlobal,
    protected documentosService: DocumentoService,
    protected session: SessionService,
    protected router: Router,
    protected ParametrosGeraisService: ParametrosGeraisService,
    protected route: ActivatedRoute
  ) {
    this.documentosGlobal.adicionaDocumentoEmitter.subscribe((add) =>
      this.addFile(add)
    );

    this.documentosGlobal.removeDocumentoEmitter.subscribe((remove) =>
      this.removeFile(remove)
    );

    // this.documentosGlobal.imagemDocumentoEmitter.subscribe(documento => this.adicionaImagem(documento));
    //
    // this.documentosGlobal.tipoDocumentoEmitter.subscribe(documento => this.adicionaTipo(documento));
  }

  ngOnInit(): void {
    this.documentosCandidato = this.candidato.getDocumentosCandidato();

    if (!this.documentos) {
      this.candidato.getTodosDocumentos().subscribe((documentosCandidato) => {
        this.documentosCandidato = documentosCandidato;
        this.candidato.setDocumentosCandidato(documentosCandidato);

        this.initialize();
      });

      return;
    }

    this.initialize();
  }

  protected initialize() {
    this.route.paramMap.subscribe((params: ParamMap) =>
      this.load(params.get("documento"))
    );
  }

  protected load(documentType: string) {
    this.documentType = documentType;

    if (!this.requiresDocumentType()) {
      return this.router.navigateByUrl("dados-pessoais");
    }

    this.setDocuments();
  }

  protected requiresDocumentType() {
    return this.documentosCandidato.some(
      (documento) => documento.TipDesURL === this.documentType
    );
  }

  protected getRequiredDocument() {
    return [
      this.documentosCandidato.find(
        (documento) => documento.TipDesURL === this.documentType
      ),
    ];
  }

  protected getDocumentTypeId() {
    const document = this.documentosCandidato.find(
      (documento) => documento.TipDesURL === this.documentType
    );

    return document.TipDocCod;
  }

  protected setDocuments() {
    const documentTypeId = this.getDocumentTypeId();
    const documentoCandidato = this.getRequiredDocument();

    this.documentos = this.documentosGlobal.setDocumentos(
      documentoCandidato,
      documentTypeId
    );
  }

  protected hasPreviousDocument() {
    const index = this.documentosCandidato.findIndex(
      (documento) => documento.TipDesURL === this.documentType
    );

    return index - 1 >= 0;
  }

  protected hasNextDocument() {
    const index = this.documentosCandidato.findIndex(
      (documento) => documento.TipDesURL === this.documentType
    );

    return this.documentosCandidato[index + 1] !== undefined;
  }

  protected getDocumentURL(index) {
    const documento = this.documentosCandidato[index];

    return documento.TipDesURL;
  }

  protected getPreviousDocumentURL() {
    const index = this.documentosCandidato.findIndex(
      (documento) => documento.TipDesURL === this.documentType
    );

    return this.getDocumentURL(index - 1);
  }

  protected getNextDocumentURL() {
    const index = this.documentosCandidato.findIndex(
      (documento) => documento.TipDesURL === this.documentType
    );

    return this.getDocumentURL(index + 1);
  }

  protected addFile(add) {
    this.documentos = this.documentosGlobal.adicionaDocumentoGlobal(
      this.documentos,
      add
    );
  }

  protected removeFile(remove) {
    this.documentos = this.documentosGlobal.removeDocumentoGlobal(
      this.documentos,
      remove
    );
  }

  protected validateDocs() {
    const result = this.documentosGlobal.validaDocumentosGlobal(
      this.documentos,
      this.getDocumentTypeId()
    );

    this.documentos = result[0];

    return result[1];
  }

  canUploadDocument() {
    return this.documentos.find(
      (documento) => documento.DocCaminho.length === 1
    );
  }

  abrirAvisoErro(mensagem) {
    Swal({
      width: 600,
      title: "Atenção",
      type: "error",
      text: mensagem,
    });
  }

  removerUltimoDocumento() {
    this.documentosGlobal.removeDocumento(
      this.documentos[this.documentos.length - 1]
    );
  }

  async checkErroDoGX(idErro: any) {
    if (idErro) {
      if (Number(idErro) === -1) {
        (
          await this.ParametrosGeraisService.getMensagemErroArquivoTamanho()
        ).subscribe((mensagemErro) => {
          this.abrirAvisoErro(mensagemErro);
        });
      } else if (Number(idErro) === -2) {
        (
          await this.ParametrosGeraisService.getMensagemErroArquivoExtensao()
        ).subscribe((mensagemErro) => {
          this.abrirAvisoErro(mensagemErro);
        });
      }

      this.removerUltimoDocumento();

      return Promise.reject("Erro ao enviar imagem para o servidor.");
    } else {
      return Promise.resolve("Imagem enviada com sucesso.");
    }
  }

  checkRedirecionamentos() {
    if (this.hasNextDocument()) {
      const url = this.getNextDocumentURL();
      return this.router.navigate(["documento", url]);
    }

    this.session.setValor("final", "true");
    this.session.setValor("temDocumentos", "true");

    if (this.session.getValor("matricula_redirecionar") === "true") {
      this.router.navigate(["/mensagem-final-matricula-online"]);
    } else {
      this.router.navigate(["/mensagem-final"]);
    }
  }

  next() {
    if (this.validateDocs()) {
      this.documentosService.uploadDocumentos(this.documentos).subscribe(
        async (response: any) => {
          const {
            Messages: {
              0: { Id: idErro },
            },
          } = response;

          await this.checkErroDoGX(idErro).then(
            (mensagemAoConseguirPostar) => {
              this.checkRedirecionamentos();
            },
            (mensagemAoDarErroNaPostagem) => {
              return;
            }
          );
        },
        (err) => {
          this.abrirAvisoErro(
            "Erro ao enviar arquivo, entre em contato com a Univali."
          );
          return;
        },
        () => {
          this.checkRedirecionamentos();
        }
      );
    }
  }

  previous() {

    let PrcTipPrc = this.session.getValor("PrcTipPrc");

    if (this.hasPreviousDocument()) {
      const url = this.getPreviousDocumentURL();

      return this.router.navigate(["documento", url]);
    }

    //Início chamado 560378 - Rafael dos Santos - 27/08/2024
    //Sessão responsável por fazer a navegação da matrícula da graduação
    if (PrcTipPrc == null || PrcTipPrc === "undefined" || PrcTipPrc == "" || PrcTipPrc == "G"){

      this.router.navigate(["/ensino-medio"]);

      //Sessão responsável por fazer a navegação na matrícula da pós graduação
    }else if (PrcTipPrc === "M" || PrcTipPrc === "D" || PrcTipPrc === "MD"){

      this.router.navigate(["/endereco"]);

    }
    //Fim chamado 560378 - Rafael dos Santos - 27/08/2024
  }
}



// WEBPACK FOOTER //
// ./src/app/documento/documento.component.ts